import { Outlet } from 'react-router-dom';

export default function Spreads() {
    return (
        <Outlet />
    )
}